import { ConfigProvider, theme, ThemeConfig } from 'antd';
import clsx from 'clsx';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { user } from '../../atoms/user';
import ResultPage from '../../components/PersonalityTestComp/ResultPage';
import TestPage from '../../components/PersonalityTestComp/TestPage';
import { pageTitle } from '../../components/shared/basic/customHead';
import { ShouldRender } from '../../components/shared/basic/ShouldRender';
import { formateErrorObject } from '../../components/shared/formateErrorObject';
import CustomLoader from '../../components/shared/Loading';
import { notify } from '../../components/shared/notify';
import { getUserPersonalityAPI } from '../../services/personalityTest';
import { User } from '../../utils/interfaces/User';
import { ZebraLearnLogo } from '../../../assets';

const config: ThemeConfig = {
  token: { colorPrimary: '#FFFFFF', fontFamily: 'inherit' },
};

const PersonalityTestPage = () => {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState<string[]>();
  const containerRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  const userData: User | undefined = useRecoilValue(user);
  const handleResult = async () => {
    try {
      setLoading(true);
      const result = await getUserPersonalityAPI();
      setResults(result?.data);
    } catch (error: any) {
      notify(formateErrorObject(error), 'error');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleResult();
  }, []);

  return (
    <div>
      <Head>
        <title>{pageTitle('Reader Personality Test')}</title>
      </Head>
      {loading ? (
        <CustomLoader />
      ) : (
        <>
          <ShouldRender
            check={userData && results?.length && results?.length >= 4}
          >
            <ConfigProvider
              theme={{ ...config, algorithm: [theme.darkAlgorithm] }}
            >
              <nav
                className={clsx(
                  'flex py-2 fixed z-50 px-3 md:px-5 lg:px-12 border-b-2 border-borderDarkGray items-center justify-between w-full h-14 lg:min-h-16 top-0 bg-bgColor bg-opacity-75 backdrop-filter backdrop-blur-md',
                )}
              >
                <div className='flex  w-full  justify-start items-center cursor-pointer'>
                  <span onClick={() => router.push('/')}>
                    <Image
                      src={ZebraLearnLogo}
                      alt='Logo'
                      priority
                      className='object-contain w-[125px] h-[14px]'
                    />
                  </span>
                </div>
              </nav>
            </ConfigProvider>
            <div
              ref={containerRef}
              id='containerRef'
              className='flex justify-center  bg-readerLightGrayBg min-h-screen'
            >
              <div
                className={clsx('pt-20 pb-10 px-5 w-full md:w-2/3 lg:w-1/2')}
              >
                <ResultPage results={results as string[]} />
              </div>
            </div>
          </ShouldRender>
          <ShouldRender
            check={!(userData && results?.length && results?.length >= 4)}
          >
            <TestPage />
          </ShouldRender>
        </>
      )}
    </div>
  );
};

export default PersonalityTestPage;
